import React from 'react'
import T from '../assests/twitter.svg'
import F from '../assests/facebook.svg'
import I from '../assests/instagram.svg'






function Footer() {
  return (
    <footer className='footer'>
        <p>Mingle with us on :</p>
        <div className="icons">
            <img src={T} className="t-logo"/>
            <img src={F} className="f-logo"/>
            <img src={I} className="i-logo"/>


        </div>
        <h4>Contact:xxx@gmail.com</h4>

    </footer>                    
  )
}

export default Footer